export default __webpack_public_path__ + "static/media/RainSounds.08230f65.wav";